/// <reference path="../../lib/app.d.ts" />

import {RoomData} from "../lib/room";
import {RoomList} from "./roomlist";
import {Collection} from "../lib/event-interface";
import logging from "../utils/log";
import {Application} from "../application/application";
export interface DrbzPromo
{
	start : number,
	end : number,
}

export interface AuthParams
{
	userbase  : string;
	tokenID   : string;
	webID	  : number;
	memberID ?: number;
	userName ?: string;
	preAuth  ?: string;
}

export interface GiftNotification
{
	roomid : number,
	memberid : number,
	username : string,
	giftid : string,
	price : number;
	extra : any,
}

export interface StreamDataRTMP
{
	serverID : string;
	address : string;
	streamName : string;
}

export interface StreamDataHLS
{
	address : string
}

export interface StreamData
{
	rtmp : StreamDataRTMP
	hls : StreamDataHLS
	webrtc : StreamDataWowza
}

export interface StreamDataWowza
{
	sdpURL : string;
	streamInfo : WowzaStreamInfo;
}

export interface WowzaStreamInfo
{
	applicationName : string;
	sessionId : string;
	streamName : string;
}

export interface JoinedRoomStreamParameters
{
	bandwidth : number;
	bufferTime : number;
	codec : string;
	fps : number;
	h264level ?: string;
	h264profile ?: string;
	keyframe : number;
	quality : number;
	resX : number;
	resY : number;
}

export interface JoinedRoomPublicData
{
	profilePic ?: string;
	primaryCat ?: string;
	streamParameters ?: JoinedRoomStreamParameters;
	toys ?: {
		default : string;
		registered: any;
	},
}

export interface JoinedRoomModeSpecific
{
	main : StreamData;
	privateMode ?: string;
	canJoin ?: boolean;
}

export interface PricingData
{
	exclusive ?: number;
	group ?: number;
	"private" ?: number;
	voyeur ?: number;
}

export interface PricingModifier
{
	name: "happyhour";
	adjustment: "percent",
	amount: number,
	start_utc: number,
	end_utc: number,
}

export interface PricingInfo
{
	standardPricing : PricingData;
	modifiers: PricingModifier[];
}

export interface ModeSetupUpdateData
{
	roomid : string;
	allowedModes ?: Array<string>;
	pricing ?: PricingData;
}

export interface JoinedRoomData
{
	roomid : string;
	screenName ?: string;
	roomMode ?: string;
	allowedModes ?: Array<string>;
	pricing ?: PricingData;
	pricingInfo ?: PricingInfo;
	publicData ?: JoinedRoomPublicData;
	modeSpecific ?: JoinedRoomModeSpecific
	streamServerType ?: string;
}

enum ConnectionStatus {disconnected, connecting, authenticating, ready}

export class FavList
{
	private TAG = "FavList";
	private onChange : (roomID : string, status : boolean) => void;
	private favs : string[]  = [];

	constructor()
	{

	}

	update(rooms : string[])
	{
		logging.log(this.TAG, "update", rooms);

		// Only allow unique values
		let rooms2 = rooms.filter((v, i) => {return rooms.indexOf(v) === i});

		let addedItems   = this.favs.filter((i) => rooms2.indexOf(i) < 0);
		let removedItems = rooms2.filter((i) => this.favs.indexOf(i) < 0);

		for(let added of addedItems) {
			if (this.onChange) this.onChange(added, true);
		}

		for(let removed of removedItems) {
			if (this.onChange) this.onChange(removed, false);
		}

		this.favs = [...rooms2];
		logging.log(this.TAG, "update", "list after change", this.favs);
	}

	setOnChange(callback : (roomID : string, status : boolean) => void) : void
	{
		this.onChange = callback;
	}

	isFav(roomID : string)
	{
		return this.favs.indexOf(roomID) >= 0;
	}

	add(roomID : string) {
		let index = this.favs.indexOf(roomID);
		logging.log(this.TAG, "add", roomID, index);
		if (index === -1) this.favs.push(roomID);
		if (this.onChange) this.onChange(roomID, true);
		logging.log(this.TAG, "add", "list after change", this.favs);
	}

	remove(roomID : string) {
		let index = this.favs.indexOf(roomID);
		logging.log(this.TAG, "remove", roomID, index);
		if (index > -1) this.favs.splice(index, 1);
		if (this.onChange) this.onChange(roomID, false);
		logging.log(this.TAG, "remove", "list after change", this.favs);
	}
}

export interface SocketMetaData
{
	roomid : string;
	from : string;
	type : string;
	to : string;
	message : any;
}

export class ChatServer
{
	webRtcCamInfo: ServerCamToCamWebRtcStreamParams;
	TAG = "[Sxc.Chat.ChatServer]";

	socket : SocketIOClient.Socket;
	status : ConnectionStatus;

	currentRoom : RoomData;
	previousRoom : RoomData;
	lastRoom : RoomData;

	onAuthenticationFailed : Function;
	onChatMessage          : Function;

	private pingTimer : number;
	private pingTestTimer : number;
	private lastPing : number = null;

	roomList : RoomList;
	favList : FavList;
	evt : Collection;

	constructor(private server : string, private auth : AuthParams, private app : Application)
	{
		this.roomList = new RoomList();
		this.favList = new FavList();
		this.status = ConnectionStatus.disconnected;
		this.evt = new Collection("chatServer");
	}

	connect()
	{
		if (this.status !== ConnectionStatus.disconnected) return;
		this.status = ConnectionStatus.connecting;

		let server = this.server;
		let auth = this.auth;

		logging.log(this.TAG, "Connecting to " + server);

		// @TODO ezt vissza kell állítani az élesbe, nem jó a hard code
		this.socket = io(server, {
		//this.socket = io('https://chatserver.apn2.com:50443', {
			reconnection: true,
			forceNew: true
		});

		this.socket.on("authenticated", (params) =>
		{
			logging.debug(this.TAG, "[socket.authenticated]", params);
			this.status = ConnectionStatus.ready;
			this.evt.trigger("authenticated", params);
		});

		this.socket.on("technicalError", (params) =>
		{
			logging.error(this.TAG, "[socket.technicalError]", params);
			this.evt.trigger("technicalError", params);
		});


		this.socket.on("webrtcCamInfo", (info : ServerCamToCamWebRtcStreamParams) =>
		{
			logging.debug(this.TAG, "[socket.webrtcCamInfo]", info);
			this.webRtcCamInfo = info;
		});

		this.socket.on("postAuthenticationFailed", (params) =>
		{
			logging.debug(this.TAG, "[socket.postAuthenticationFailed]", params);
			this.disconnect();
			this.evt.trigger("disconnect", params.reason);
		});

		this.socket.on("favList", (rooms) =>
		{
			this.favList.update(rooms);
		});

		this.socket.on("creditChange", (data) =>
		{
			logging.log(this.TAG, "[socket.creditChange]", data);
			this.evt.trigger("creditChange", data);
		});

		this.socket.on("error", (data) =>
		{
			logging.error(this.TAG, "[socket.error]", data);
		});

		this.socket.on("favUpdate", (data) =>
		{
			logging.log(this.TAG, "[socket.favUpdate]", data);
			let method = data.status ? "add" : "remove";
			this.favList[method](data.roomid);
		});

		this.socket.on("authentiationFailed", () =>
		{
			this.disconnect();
			this.evt.trigger("disconnect", "authenticationFailed");
		});

		this.socket.on('disconnect', (...args) =>
		{
			logging.debug(this.TAG, "[socket.disconnect]", args);
			this.disconnect();

			// this.evt.trigger("disconnect", "disconnect");
		});

		this.socket.on('connect_error', (...args) => {
			logging.error(this.TAG, "[socket.connect_error]", args);
			this.disconnect();
			this.evt.trigger("disconnect", "connectError");
		});

		this.socket.on('connect_timeout', (...args) => {
			logging.debug(this.TAG, "[socket.connect_timeout]", args);
			this.evt.trigger("disconnect", "connectTimeout")
		});

		this.socket.on('forceTerminate', (reason) => {
			// logging.debug(this.TAG, "[socket.forceTerminate]", reason);
			this.evt.trigger("forceTerminate", reason);
		});

		this.socket.on('chatMessage', this.onChatMessage);

		this.socket.on('metaData', (params) => {
			logging.debug(this.TAG, "[socket.metaData]", params);
			this.evt.trigger("metaData", params);
		});

		this.callMethod("registerRoomStatusCallback", {});

		this.socket.on('roomStatusChange', (room : JoinedRoomData) =>
		{
			// logging.debug(this.TAG, "[socket.roomStatusChange]", room);
			let prev = {...this.roomList.getByID(room.roomid)};
			room.roomid = room.roomid.toString();

			if (this.currentRoom && room.roomid === this.currentRoom.getID()) {
				this.currentRoom.setJoinData(room);
			}

			if (this.lastRoom && room.roomid === this.lastRoom.getID()) {
				this.lastRoom.setJoinData(room);
			}

			this.evt.trigger("roomStatusChange", room, prev);
			this.roomList.update(room);
		});

		this.socket.on('roomModeSetupChange', (room : JoinedRoomData) => {
			logging.debug(this.TAG, "[socket.roomModeSetupChange]", room);
			room.roomid = room.roomid.toString();
			this.roomList.updateModeSetup(room);
			this.evt.trigger("roomModeSetupChange", room);
		});

		this.socket.on('promotedToPrivateOwner', (data : any) => {
			logging.debug(this.TAG, "[socket.promotedToPrivateOwner]", data);
			this.evt.trigger("promotedToPrivateOwner", data);
		});

		this.socket.on('roomPaused', (data : any) => {
			logging.debug(this.TAG, "[socket.roomPaused]", data);
			this.evt.trigger("roomPaused", data);
			// this.roomList.update(room);
		});

		this.socket.on('roomResumed', (data : JoinedRoomData) => {
			logging.debug(this.TAG, "[socket.roomResumed]", data);
			this.evt.trigger("roomResumed", data);
			// this.roomList.update(room);
		});

		this.socket.on("ping", (...args) => {
			// logging.log(this.TAG, "Ping", ...args);
		});

		this.socket.on("pong", (...args) => {
			// logging.log(this.TAG, "Ping", ...args);
		});

		this.socket.on('connect', () =>
		{
			logging.debug(this.TAG, "[socket.connect]", "Connection ready.", this.socket.id);
			this.doAuthentication(auth);

			this.lastPing = null;
			this.pingTimer = setInterval(this.ping.bind(this), 5000);
			this.pingTestTimer = setInterval(this.pingTest.bind(this), 2500);
		});

		this.socket.on("removedFromRoom", (data) =>
		{
			logging.debug(this.TAG, "[socket.removedFromRoom]", data);
			this.evt.trigger("removedFromRoom", data.roomid, data.reason, data);
		});

		this.socket.on("giftNotification", (data : GiftNotification) =>
		{
			logging.debug(this.TAG, "[socket.giftNotification]", data);
			this.evt.trigger("giftNotification", data);
		});

		this.socket.on("cam2camSignaling", (data) =>
		{
			logging.debug(this.TAG, "[socket.cam2camSignaling]", data);
			this.evt.trigger("cam2camSignaling", data);
		});

		this.socket.on("joinRoomSuccessful", (data) =>
		{
			logging.debug(this.TAG, "[socket.joinRoomSuccessful]", data);
			this.evt.trigger("joinRoomSuccessful", data);
		});

		this.socket.connect();
	}

	private currentDrbz = null;

	/**
	 * Makes sure the last ping happened recently. If not, triggers a disconnect
	 */
	private pingTest()
	{
		if (!this.socket.connected) return;

		if (this.lastPing !== null && Date.now() - this.lastPing > 20 * 1000)
		{
			this.evt.trigger("disconnect", "ping");
			logging.error(this.TAG, "[ping]", "Ping timeout");
			this.disconnect();
		}
	}

	/**
	 * Pings the server, and if that's successful stores the last successful ping time
	 */
	public ping()
	{
		// Ping only if connected
		if (!this.socket.connected) return;

		this.socket.emit("pingping", {"ping": true}, (res) =>
		{
			this.lastPing = Date.now();
		});
	}

	private doAuthentication(auth : AuthParams)
	{
		this.status = ConnectionStatus.authenticating;

		logging.log(this.TAG, "[doAuthentication]", auth);

		if (auth.tokenID == 'guest') {
			this.call({
				'authenticate': 'guest',
				'userbase': auth.userbase,
				'webid': auth.webID,
				'pingTimeout': 30
			});
		} else {
			this.call({
				'authenticate': 'member',
				'webid': auth.webID,
				'tokenid': auth.tokenID,
				'username': auth.userName,
				'memberid': auth.memberID,
				'preauth': auth.preAuth, // TODO: this.auth.preAuth
				'pingTimeout': 30
			});
		}
	}

	callMethod(method : string, extra = {}, callback = null)
	{
		logging.debug(this.TAG, "[callMethod]", method, extra);

		var options = jQuery.extend({}, extra, {method : method});

		if (callback)
			this.socket.emit("call", options, callback);
		else
			this.socket.emit("call", options);
	}

	call(options, callback : Function = null)
	{
		logging.debug(this.TAG, "[call]", [options]);

		if (callback)
			this.socket.emit("call", options, callback);
		else
			this.socket.emit("call", options);
	}

	/**
	 * Disconnects from the chat server and cancels all one time events
	 */
	disconnect()
	{
		logging.error(this.TAG, "[disconnect]");

		this.status = ConnectionStatus.disconnected;

		clearInterval(this.pingTestTimer);
		clearInterval(this.pingTimer);

		this.socket.off("joinRoomSuccessful");
		this.socket.off("joinRoomFailed");
		this.socket.off("leaveRoomSuccessful");
		this.socket.off("leaveRoomFailed");

		if (!this.socket.disconnected) {
			this.socket.close();
			this.socket.disconnect();
		}

		this.currentRoom = null;
	}

	sendChatMessage(message : string)
	{
		// @ts-ignore
		if(typeof warnPoint != 'undefined' && warnPoint >= 2) { return; }

		return new Promise((resolve, reject) => {
			this.callMethod("sendChatMessage", {
				roomid: this.currentRoom.getID() + "",
				message: {
					"type": "chat",
					"text": message
				}
			}, (data) => {
				if(data.success == true) {
					resolve();
				} else {
					reject(data.reason);
				}
			});
		});
	}

	sendGift(roomID : string, giftID : string, message : string, price : number, onSuccess : Function, onFail : Function)
	{
		this.socket.once("sendGiftSuccess", (params) => {
			logging.debug(this.TAG, "[socket.sendGiftSuccess]", params);
			this.socket.off("sendGiftFailed");
			onSuccess(params);
		});

		this.socket.once("sendGiftFailed", (params) => {
			logging.debug(this.TAG, "[socket.sendGiftFailed]", params);
			this.socket.off("sendGiftSuccess");
			onFail(params);
		});

		this.callMethod("sendGift", {
			roomid: roomID + "",
			message: message,
			giftid: giftID,
			price: price,
			extra: {
				price: price
			},
		});
	}

	joinRoom(roomID : string, mode : string, onSuccess : (JoinedRoomData) => void, onFail : Function)
	{
		this.currentRoom = new RoomData(roomID);
		this.lastRoom = this.currentRoom;

		let successHandler = (data) => {
			logging.log(this.TAG, "[joinRoom][successful]", data);
			this.currentRoom.setJoinData(data);
			this.socket.off("joinRoomFailed", failedHandler);
			if (onSuccess) onSuccess(data);
		};

		let failedHandler = (data) => {
			logging.log(this.TAG, "[joinRoom][failed]", data);
			this.lastRoom.setJoinData(data);
			this.currentRoom = null;
			this.socket.off("joinRoomSuccessful", successHandler);
			if (onFail) onFail(data);
		};

		this.socket.once('joinRoomSuccessful', successHandler);
		this.socket.once("joinRoomFailed", failedHandler);

		this.callMethod("joinRoom", {
			roomid: roomID as string,
			dropOldClient: true,
			mode: mode
		});
	}

	reloadRoomList(onReady : Function)
	{
		logging.log(this.TAG, "[getRoomList]");

		// getRoomList filter {filter: { 'roomid' : [123] }}

		this.callMethod("getRoomList", {}, (roomList) =>
		{
			// logging.log(this.TAG, "[getRoomList] result", roomList);
			const list = [];

			Object.keys(roomList).forEach((key) => {
				list.push(roomList[key]);
			});

			this.roomList.evt.one("ready", () => {
				onReady();
			});

			this.roomList.initialize(list);
			this.app.view.samplerPanel.update();

		});
	}

	leaveCurrentRoom(onSuccess : (room : any) => void, onFail : (reason : string) => void):void
	{
		if (!this.currentRoom) return;
		logging.log(this.TAG, "[leaveCurrentRoom]");

		this.socket.off('leaveRoomSuccessful');
		this.socket.off('leaveRoomFailed');

		this.socket.once('leaveRoomSuccessful', (room) =>
		{
			this.socket.off('leaveRoomSuccessful');
			this.socket.off('leaveRoomFailed');
			this.currentRoom = null;

			if (onSuccess) onSuccess(room);
		});

		this.socket.once('leaveRoomFailed', (response) =>
		{
			this.socket.off('leaveRoomSuccessful');
			this.socket.off('leaveRoomFailed');

			this.currentRoom = null;

			if (onFail) onFail(response.reason);
		});

		this.callMethod("leaveRoom", {roomid: this.currentRoom.getID() + ""});
	}

	/**
	 * Returns true if the chat server is done connecting, authenticating, etc
	 *
	 * @returns {boolean}
	 */
	isReady() : boolean
	{
		return this.status === ConnectionStatus.ready;
	}

	/**
	 * Returns true if the chat server is in progress of connecting, authenticating, etc.
	 * @returns {boolean}
	 */
	willBeReady() : boolean
	{
		return this.status !== ConnectionStatus.disconnected;
	}

	requestChatMode(roomID : string, mode : string, onSuccess : Function, onFail : Function):void
	{
		this.currentRoom = new RoomData(roomID);
		this.lastRoom = this.currentRoom;

		let successHandler = (data) => {
			logging.log(this.TAG, "[requestChatMode][successful]", data);
			this.currentRoom.setJoinData(data);
			this.socket.off("joinRoomFailed", failedHandler);
			if (onSuccess) onSuccess(data);
		};

		let failedHandler = (data) => {
			logging.error(this.TAG, "[requestChatMode][failed]", data);
			this.lastRoom.setJoinData(data);
			this.currentRoom = null;
			this.socket.off("joinRoomSuccessful", successHandler);
			if (onFail) onFail(data);
		};

		this.socket.once('joinRoomSuccessful', successHandler);
		this.socket.once("joinRoomFailed", failedHandler);

		this.callMethod("requestChatMode", {roomid: roomID + "", mode : mode}, (data) =>
		{
			logging.log(this.TAG, "[requestChatMode][ack]", data);
			if (!data.success) {
				onFail(data.reason);
			}
		});
	}

	getWebRtcCamInfo() {
		return this.webRtcCamInfo;
	}

	startCamToCam(mode : string) : Promise<ServerCamToCamStreamParams>
	{
		return new Promise((resolve, reject) =>
		{
			this.socket.once("camStreamError", (data) =>
			{
				this.socket.off("camStreamPublishDetails");
				reject(data.reason);
			});

			this.socket.once("camStreamPublishDetails", (data) =>
			{
				logging.log(this.TAG, "cam2cam ready", data);
				this.socket.off("camStreamError");
				if (mode === "rtmp")
				{
					resolve({
						serverAddress: data.serverAddress,
						streamName: data.streamName,
					});
				}
				else
				{
					resolve({
						socketURL: data.socketURL,
						applicationName: data.applicationName,
						streamName: data.streamName,
					});
				}
			});

			switch (mode)
			{
				case "rtmp":
					this.callMethod("startCamStream", {
						mode: "rtmp",
						autoCam2Cam: true
					});
					break;

				case "webrtc":

					const data = {
						mode: "webrtc",
						autoCam2Cam: true,
					};

					this.callMethod("startCamStream", data);
					resolve(this.webRtcCamInfo);
					break;
			}
		});

	}

	stopCamToCam()
	{
		this.callMethod("stopCamStream");
	}

	camToCamSignaling(roomID : string, message : object) {
		// TODO add callback to handle ack
		this.callMethod("cam2camSignaling", { roomid : roomID.toString(), message: message });
	}

	setFav(roomID : string, status : boolean) : void
	{
		this.callMethod("setFav", {roomid : roomID.toString(), status: status})
	}

	sendSticker(stickerID: string)
	{
		this.sendChatMessage("#sticker:" + stickerID);
	}
}

interface ServerCamToCamFlashStreamParams
{
	serverAddress : string;
	streamID : string;
}

interface ServerCamToCamWebRtcStreamParams
{
}

type ServerCamToCamStreamParams = ServerCamToCamWebRtcStreamParams | ServerCamToCamFlashStreamParams;

